// extracted by mini-css-extract-plugin
module.exports = {"paper":"GroupCard_paper__3+Z86","actions":"GroupCard_actions__UzeyZ","loadingIndicator":"GroupCard_loadingIndicator__qYli9","table":"GroupCard_table__jFZDX"};